export * from "ce/plugins/Linting/utils/isLintErrorLoggingEnabledForEntity";
import { default as CE_isLintErrorLoggingEnabledForEntity } from "ce/plugins/Linting/utils/isLintErrorLoggingEnabledForEntity";
export default CE_isLintErrorLoggingEnabledForEntity;
